import {Editor, Element} from "../../../../../../pkg/slate.js";
export const isBlockActive = (editor, format) => {
  const [match] = Editor.nodes(editor, {
    match: (n) => !Editor.isEditor(n) && Element.isElement(n) && n.type === format
  });
  return !!match;
};
